import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const Root = styled(Box)(({ theme }) => ({
  width: "80%",
  padding: theme.spacing(0),
}));

interface TabPanelProps {
  children?: React.ReactNode;
}

const TabPanel: React.FC<TabPanelProps> = (props: TabPanelProps) => {
  const { children } = props;
  return <Root>{children}</Root>;
};

export default TabPanel;
